/* eslint-disable indent */
import shortid from 'shortid';
import DADOS_SIM from '../../consts/consts';
import SessionService from './../../session/session-service';

const enderecoValues = DADOS_SIM.ENDERECO;

/**
 * Types
 */

export const enderecosTypes = {
    ADICIONAR_ENDERECO: 'enderecos/ADICIONAR_ENDERECO',
    ATUALIZA_ENDERECO: 'enderecos/ATUALIZA_ENDERECO',
    EXCLUIR_ENDERECO: 'enderecos/EXCLUIR_ENDERECO',
    POPULATE_ENDERECO_FROM_STORAGE: 'enderecos/POPULATE_ENDERECO_FROM_STORAGE',
    RESET: 'enderecos/RESET'
};

/**
 * Reducer
 */
let INITIAL_STATE = {
    [enderecoValues.THIS]: null
};

const atualizaEndereco = (listaEndereco, novoEndereco) => {
    try {
        return listaEndereco.map((endereco) => {
            if (endereco.id !== novoEndereco.id) {
                return endereco;
            }

            return novoEndereco;
        });
    } catch (error) {
        console.error('Ocorreu um erro ao atualizar o endereco, atualizaEndereco()');
        throw error;
    }
};

const excluiEndereco = (listaEndereco, idEndereco) => {
    try {
        return listaEndereco.filter((endereco) => endereco.id !== idEndereco);
    } catch (error) {
        console.error('Ocorreu um erro ao excluir o endereco, excluiEndereco()');
        throw error;
    }
};

const setEnderecoSession = (listaEndereco) => {
    let objSession = SessionService.getSession();

    SessionService.setSession({
        ...objSession,
        [enderecoValues.THIS]: listaEndereco
    });
};

export function enderecosReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case enderecosTypes.POPULATE_ENDERECO_FROM_STORAGE: {
            const session = SessionService.getSession();
            if (session) {
                return {
                    ...state,
                    [enderecoValues.THIS]: session[enderecoValues.THIS] ? session[enderecoValues.THIS] : []
                };
            }
            return { ...state };
        }
        case enderecosTypes.RESET: {
            return { ...INITIAL_STATE };
        }
        case enderecosTypes.ADICIONAR_ENDERECO: {
            let novoEndereco = action.payload.endereco;
            novoEndereco = {
                id: shortid.generate(),
                ...novoEndereco
            };

            setEnderecoSession([...state[enderecoValues.THIS], novoEndereco]);

            return {
                ...state,
                [enderecoValues.THIS]: [...state[enderecoValues.THIS], novoEndereco]
            };
        }
        case enderecosTypes.ATUALIZA_ENDERECO: {
            setEnderecoSession(atualizaEndereco(state[enderecoValues.THIS], action.payload.endereco));

            return {
                ...state,
                [enderecoValues.THIS]: atualizaEndereco(state[enderecoValues.THIS], action.payload.endereco)
            };
        }
        case enderecosTypes.EXCLUIR_ENDERECO: {
            setEnderecoSession(excluiEndereco(state[enderecoValues.THIS], action.payload.id));

            return {
                ...state,
                [enderecoValues.THIS]: excluiEndereco(state[enderecoValues.THIS], action.payload.id)
            };
        }
        default:
            return state;
    }
}

/**
 * Actions
 */

export const Creators = {
    adicionaEndereco: (endereco) => ({
        type: enderecosTypes.ADICIONAR_ENDERECO,
        payload: { endereco }
    }),

    atualizaEndereco: (endereco) => ({
        type: enderecosTypes.ATUALIZA_ENDERECO,
        payload: { endereco }
    }),

    excluiEndereco: (id) => ({
        type: enderecosTypes.EXCLUIR_ENDERECO,
        payload: { id }
    }),
    reset: () => ({
        type: enderecosTypes.RESET
    }),
    populateEnderecoFromStorage: () => ({
        type: enderecosTypes.POPULATE_ENDERECO_FROM_STORAGE
    })
};
